export default {
  app: {
    languagePopup: {
      title: 'Pašlaik izmantojat {logo} angļu valodas versiju',
      subtitle: 'Vai vēlaties pārslēgties uz vēlamo valodu?',
      cta: 'Pārslēgt uz {lang}',
    },
  },
};
